import { useTranslation } from '@klv/hooks/useTranslation';
import { generateClassName } from '@klv/shared/utils/functions';
import { FeaturesList } from './features-list';
import * as styles from './styles/planCard.module.css';
import type { IPlanCard } from './types';

const PlanCard = ({
  contacts,
  description,
  featuresList,
  emailSends,
  id,
  name,
  price,
  credits,
  messagingType,
  ...props
}: IPlanCard) => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;

  const formattedPrice = price ? new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(price) : '';

  const renderFeaturesList = (expandFlag: boolean) => {
    const itemsToDisplay = expandFlag ? featuresList : featuresList?.slice(0, 6);
    return itemsToDisplay?.map((item) => (
      <div>
        <FeaturesList key={item?.listText} listIcon={item?.listIcon} listText={item?.listText} />
      </div>
    ));
  };

  return (
    <div id={id} className={styles.planCard} {...props}>
      <div className={styles.cardContents}>
        <div className={generateClassName([styles.planNameContainer])}>
          <div className={styles.planName}>{name}</div>
          {name === t('organisms_pricing_plans_emailPlusSms_name') && (
            <div className={styles.recommended}>
              <div className={styles.recommendedText}>
                {t('organisms_pricing_plans_emailPlusSms_recommended')}
              </div>
            </div>
          )}
        </div>
        <div className={generateClassName([styles.statsContainer])}>
          <div aria-live="polite" className={styles.priceWrapper}>
          <div className={styles.amount}>{formattedPrice}</div>
          <div className={styles.timePeriod}>{t('organisms_pricing_per_month')}</div>          </div>
            <div className={name === t('organisms_pricing_plans_email_name') ? styles.emailSendsContainer : styles.emailSendsPlusContainer}>
              <div className={styles.emailSendsText}>
              {new Intl.NumberFormat(locale).format(emailSends)} {t('organisms_pricing_plans_email_emails_label')}
              {name === t('organisms_pricing_plans_emailPlusSms_name') ? <> +</> : <> {t('organisms_pricing_per_month')}</>}
              </div>
              <div className={styles.smsSubText}>
                {credits ? new Intl.NumberFormat(locale).format(credits) : ''} {' '}
                {t('organisms_pricing_plans_emailPlusSms_creditsSubText')}
              </div>
            </div>  
        </div>
        <div className={styles.divider} />
        <div className={styles.featuresListContainer}>
          {renderFeaturesList(true)}
        </div>
      </div>
    </div>
  );
};

export default PlanCard;

